/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LLMMessageOriginator {
  USER = "USER",
  LLM = "LLM",
}

export const LLMMessageOriginatorDisplay: Record<LLMMessageOriginator, string> = {
  [LLMMessageOriginator.USER]: "User",
  [LLMMessageOriginator.LLM]: "LLM",
};
